"use client";

import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ServiceProps } from "./interfaces";

export const ServiceCard = ({ service }: { service: ServiceProps }) => {
  return (
    <motion.div
      className={`relative bg-white rounded-xl p-8 flex flex-col items-center text-center border border-gray-200 hover:shadow-lg transition-all overflow-hidden ${service.bgClass}`}
    >
      <div className="bg-white p-4 rounded-full shadow-sm mb-6 z-10 relative">
        <FontAwesomeIcon
          icon={service.icon}
          className={`w-5 h-5 ${service.color}`}
        />
      </div>

      <h3 className="text-xl font-bold text-gray-900 mb-3 z-10 relative">
        {service.title}
      </h3>

      <p className="text-sm leading-relaxed text-gray-600 z-10">
        {service.description}
      </p>
    </motion.div>
  );
};
